import { Routes, Route, Navigate } from 'react-router'

import Unauthorized from './components/views/Unauthorized/Unauthorized'
import Homepage from './components/views/Homepage/Homepage'
import Events from './components/views/Events/Events'
import Approvals from './components/views/Approvals/Approvals'
import Roles from './components/views/Roles/Roles'
import Alliances from './components/views/Alliances/Alliances'
import Legions from './components/views/Legions/Legions.jsx'
import Preferences from './components/views/Preferences/Preferences.jsx'
import Account from './components/views/Account/Account.jsx'
import FixedMge from './components/views/FixedMge/FixedMge.jsx'
import Character from './components/views/Character/Character.jsx'
import Characters from './components/views/Characters/Characters.jsx'
import StellarSeasons from './components/views/StellarSeasons/StellarSeasons.jsx'
import { useCharacters } from './contexts/Characters'
import { useUser } from './contexts/User.js'
import { Roles as AppRoles } from './utilities/constants.js'
import User from './components/views/User/User.jsx'
import Login from './components/domain/Login/Login.jsx'
import Users from './components/views/Users/Users.jsx'

const AppRoutes = () => {
    const characters = useCharacters()
    const user = useUser()

    const routes = [
        { path: '/', component: <Homepage /> },
        { path: '/login', component: <Login /> },
        { path: '/events', component: <Events /> },
        { path: '/mge', component: <FixedMge /> },
        { path: '/account', component: <Account />, authorized: user.$state },
        { path: '/approvals', component: <Approvals />, authorized: characters.authorized([AppRoles.developer, AppRoles.admin, AppRoles.leader]) },
        { path: '/roles', component: <Roles />, authorized: characters.authorized([AppRoles.developer, AppRoles.admin]) },
        { path: '/alliances', component: <Alliances />, authorized: characters.authorized([AppRoles.developer, AppRoles.admin]) },
        { path: '/legions', component: <Legions />, authorized: characters.authorized([AppRoles.developer, AppRoles.admin, AppRoles.leader]) },
        { path: '/preferences', component: <Preferences /> },
        { path: '/stellarSeasons', component: <StellarSeasons /> },
        { path: '/characters/:characterId', component: <Character /> },
        { path: '/characters', component: <Characters /> },
        { path: '/users/:userId', component: <User />, authorized: characters.authorized([AppRoles.developer]) },
        { path: '/users', component: <Users />, authorized: characters.authorized([AppRoles.developer]) },
    ]

    return (
        <Routes>
            {routes.map((route) => <Route path={route.path} element={(route.authorized || route.authorized === undefined) ? route.component : <Unauthorized />} key={route.path} />)}
        </Routes>
    )
}

export default AppRoutes